<template>
  <div class="dash-root">
    <b-container fluid>
      <b-row class="p-0">
        <div lg="3" class="p-0 sidebar-class">
          <div class="dashside">
            <div class="dashtext"></div>
            <orgDashboardNavLinks navbody="navbody" />
          </div>
        </div>

        <div lg="9" class="body-class p-0 m-0">
          <b-modal
            id="modal-logout"
            centered
            title="Confirm Exit"
            ok
            ok-variant="success"
            @cancel="hide2nd()"
            cancel-variant="danger"
            @ok="loggingOut()"
          >
            <template v-slot:modal-ok> Yes, Logout </template>
            <p>Are You sure you want to Logout?</p>
          </b-modal>
          <div class="nav-admin-header">
            <NavHeaderAdmin />
          </div>
          <div class="p-3 view-wrapper">
            <router-view class="dash-root"></router-view>
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import NProgress from 'nprogress'
// import store from "@/store";
import { mapState, mapActions } from "vuex";
import orgDashboardNavLinks from "@/components/organization/orgDashboardNavLinks";
import NavHeaderAdmin from "@/components/admin/NavHeaderAdmin.vue";

export default {
  components: {
    orgDashboardNavLinks,
    NavHeaderAdmin,
  },
  created() {
    if (!this.loggedin) {
      this.$router.push({
        name: "landing",
        query: { redirect: this.$route.fullPath },
      });
    }
  },
  data() {
    return {
      curD: new Date(),
      shownoti: true,
    };
  },
  mounted() {
    // if (!this.loggedin) {
    //     this.$router.push({
    //         name: "landing",
    //         query: { redirect: this.$route.fullPath }
    //     });
    // }
  },
  // beforeRouteEnter(to, from, next) {

  //     next();
  // },
  methods: {
    ...mapActions(["logOut"]),
    logout() {
      if (confirm("Are you sure you want to log out? Saved Changes may be lost")) {
        this.logOut().then(() => {
          this.$router.push({
            name: "login",
          });
        });
      }
    },
    confirmLogout() {
      this.$bvModal.show("modal-logout");
    },
    loggingOut() {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;
      this.logOut().then(() => {
        this.$router.push({
          name: "login",
        });
      });
    },
    hide2nd() {
      this.$bvModal.hide("modal-logout");
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      start_config: (state) => state.exam.start_config,
      // plan: (state) => state.loginmaster.details.plan,
      trial: (state) => state.loginmaster.trial,
      premium: (state) => state.loginmaster.details.premium_details,
      started: (state) => state.exam.started,
      allinsti: (state) => state.exam.allinstitutions,
    }),
  },
};
</script>

<style scoped>
.nav-admin-header {
  height: 80px;
  position: fixed;
  background: white;
  z-index: 999;
  width: 75%;
  display: hidden;
  box-shadow: 2px 2px 3px 0px;
  margin-bottom: 10px;
  margin-left: 0px;
  margin-top: -15px;
}

.view-wrapper {
  margin-top: 70px;
}
.dashside {
  background-color: #263056;
  color: white;
  margin-top: -16px;
  height: 100%;
  padding-top: 10px;
  min-height: 70px;
  position: fixed;
  z-index: 999;
  width: 25%;
  overflow: auto;
  scrollbar-width: thin;
}
.dashtext {
  font-size: 25px;
  font-family: "Times New Roman", Times, serif;
  color: white;
}

.dashlink {
  display: flex;
  font-size: 20px;
  margin-top: 2rem;
  text-decoration: none;
  color: white;
  padding: 3px;
}
.active {
  border-right: 20px solid #263056;
  color: #263056;
}
.mactive {
  color: white;
  border-right: 20px solid red;
}
.dash-root {
  background-color: #fbfbfb;
}
.avatar {
  width: 55px;
  height: 45px;
  border-radius: 5px 5px;
  background-color: white;
  display: inline-block;
  cursor: pointer;
}

.img-dp {
  width: 55px;
  height: 55px;
  display: inline-block;
  border-radius: 5px 5px;
}
.noti-icon {
  position: relative;
  left: -15px;
  top: 10px;
  cursor: pointer;
}
.dropdown-button {
  background-color: white;
}
.sbb {
  border: 0px;
  z-index: 9999px;
}
.noti-badge {
  position: relative;
  left: -25px;
}
.noti-body {
  position: absolute;
  z-index: 999;
  top: 80px;
  right: 10px;
  min-height: 30vh;
  width: 400px;
  border-radius: 10px 10px;
}

.list-noti {
  border-bottom: 1px solid rgb(58, 55, 55);
  background-color: rgb(245, 245, 249);
  width: full-width;
  display: flex;
}

.list-noti-body {
  text-align: left;
}
.noti-img {
  width: 60px;
  height: 60px;
  border-radius: 100px 100px;
}
.noti-subject {
  font-weight: bold;
}
.noti-text {
  font-size: 0.8rem;
}

.body-class {
  width: 75%;
}

.sidebar-class {
  width: 25%;
}

@media screen and (max-width: 999px) {
  .profile-tabs {
    display: flex;
    position: absolute;
    right: 5%;
    top: -100px;
  }
  .noti-body {
    top: 50px;
    right: -10px;
    width: 300px;
  }
  .dashside {
    display: none;
  }

  .nav-admin-header {
    width: 103%;
    box-shadow: 2px 2px 3px 0px;
    margin-bottom: 10px;
  }
  .body-class {
    width: 100%;
  }
}
@media screen and (min-width: 768px) {
  .sbb {
    display: none;
  }

  .noti-icon {
    position: relative;
    left: -5px;
    top: 10px;
  }
  .noti-badge {
    position: relative;
    left: -15px;
  }
}
</style>
